// src/oura/merchant/StartAnswering.tsx
//
// Two pieces every merchant page head shares: the sentence with its late
// part in rose, and "Start answering", the one action verb on Home,
// Decisions and Work (specs v1.1, B0.7). It shows while anything needs them
// and walks the whole queue in the drawer, one item at a time.

import { LATE_TEXT, PillButton, TAP_TARGET } from "@oura/ui";
import { cn } from "../lib/cn";
import type { SentenceParts } from "./docAsks";
import { useMerchantDrawers } from "./useMerchantDrawers";

/** A page sentence with its late part in rose: "9 things need you, 3 late." or two sentences. */
export function Sentence({ parts, joiner = " " }: { parts: SentenceParts; joiner?: string }) {
    return (
        <>
            {parts.text}
            {parts.late && (
                <>
                    {joiner}
                    <span className={LATE_TEXT}>{parts.late}</span>
                </>
            )}
        </>
    );
}

/** "Start answering", from `startId` when it is in the queue. Nothing while nothing needs them. */
export function StartAnswering({ startId }: { startId?: string | null }) {
    const { queue, openQueue } = useMerchantDrawers();
    if (queue.length === 0) return null;
    return (
        <PillButton variant="primary" onClick={() => openQueue(startId ?? undefined)} className={cn(TAP_TARGET, "max-sm:h-11 max-sm:px-5")}>
            Start answering
        </PillButton>
    );
}
